<template>
  <v-app>
    <HandleCache ref="cacheBuster">

      <template v-slot="{ isLoading, isLatestVersionAvailable }">
        <UpdateOverlay
            :showOverlay="updateAvailable"
            @update="applyUpdate"
        />

        <div v-if="initializationError">
          {{ $t('common.initializationError', { error: initializationError }) }}
        </div>
        <div v-else>

          <h1 v-if="isLoading">{{ $t('common.loading') }}</h1>
          <template v-else-if="isLatestVersionAvailable">
            <OfflineIndicator />
            <PwaNotification />
            <NotificationsList />
            <PopupNotification v-for="(popupUserNotification, indexPopupUserNotification) in popupUserNotifications"
                               :key="indexPopupUserNotification"
                               :notification="popupUserNotification"
            />
            <PopupAnnouncementMessage v-for="(popupAnnouncementMessageUserNotification, indexPopupAnnouncementMessageUserNotification) in popupAnnouncementMessageUserNotifications"
                                      :key="indexPopupAnnouncementMessageUserNotification"
                                      :notification="popupAnnouncementMessageUserNotification"
            />
            <!--          <UserNotifications />-->
            <TermsAndConditions :style="tenantcolor" />
            <template v-if="isMobileRoute && isLoggedIn">
              <div class="mobile-content">
                <div class="main">
                  <div v-if="hasContentLoaded" :style="tenantcolor">
                    <router-view />
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="isMobilePage">
              <div class="content">
                <div v-if="isLoggedIn" class="bottombar" :style="tenantcolor"></div>
                <div class="main">
                  <div v-if="hasContentLoaded" :style="tenantcolor">
                    <router-view />
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <MainNav v-if="hasContentLoaded && isLoggedIn" />
              <div class="content">
                <div v-if="isLoggedIn" class="bottombar" :style="tenantcolor"></div>
                <div class="main">
                  <div v-if="hasContentLoaded" :style="tenantcolor">
                    <router-view />
                  </div>
                </div>
              </div>
            </template>
          </template>


        </div>
      </template>
    </HandleCache>
    <Overlay v-if="isLoading" :mobile="isMobile" />
  </v-app>
</template>

<script>
import { onMounted, computed, onBeforeUnmount, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from "vue-router"
import { useDevice } from '@/composables/useDevice'

//import { Hub } from '@aws-amplify/core' // Add this import


import {getAuthToken } from '@/services/auth'
import { updateAvailable, applyUpdate } from '@/registerServiceWorker'
import { registerCacheListeners } from '@/services/cacheManager'

//import commovisconfig from '@/services/config'
//import Amplify, { Auth } from 'aws-amplify'
//import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components'


import HandleCache from '@/HandleCache.vue'
import PwaNotification from '@/components/mobile/PwaNotification.vue'
import NotificationsList from "@/components/notifications/NotificationsList.vue"
import UserNotifications from "@/components/userNotifications/UserNotifications.vue"
import MainNav from "@/components/MainNav.vue"
import TermsAndConditions from "@/components/common/TermsAndConditions.vue"
import Overlay from '@/components/Overlay'
import UpdateOverlay from '@/components/UpdateOverlay.vue'
import OfflineIndicator from '@/components/common/OfflineIndicator.vue'


import Footer from '@/components/Footer'
import Logon from '@/components/auth/Logon'
import SidebarNav from "@/components/SidebarNav";
import PageNotFound from "@/views/PageNotFound";
import SidebarNavMobile from "@/components/SidebarNavMobile";
import MobileInformation from "@/components/mobile/MobileInformation.vue";
import PopupNotification from "@/components/userNotifications/PopupNotification.vue";
import PopupAnnouncementMessage from "@/components/userNotifications/PopupAnnouncementMessage.vue";








function increase_brightness(hex, percent) {
  // strip the leading # if it's there
  hex = hex.replace(/^\s*#|\s*$/g, '')

  // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
  if (hex.length == 3) {
    hex = hex.replace(/(.)/g, '$1$1')
  }

  var r = parseInt(hex.substr(0, 2), 16),
    g = parseInt(hex.substr(2, 2), 16),
    b = parseInt(hex.substr(4, 2), 16)

  return (
    '#' +
    (0 | ((1 << 8) + r + ((256 - r) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + g + ((256 - g) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + b + ((256 - b) * percent) / 100)).toString(16).substr(1)
  )
}
function decrease_brightness(hex, percent) {
  var r = parseInt(hex.substr(1, 2), 16),
    g = parseInt(hex.substr(3, 2), 16),
    b = parseInt(hex.substr(5, 2), 16)

  return (
    '#' +
    (0 | ((1 << 8) + (r * (100 - percent)) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + (g * (100 - percent)) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + (b * (100 - percent)) / 100)).toString(16).substr(1)
  )
}

export default {

  name: 'App',

  components: {
    PopupAnnouncementMessage,
    PopupNotification,
    SidebarNavMobile,
    PageNotFound,
    SidebarNav,
    MainNav,
    NotificationsList,
    UserNotifications,
    Footer,
    Overlay,
    Logon,
    TermsAndConditions,
    MobileInformation,
    PwaNotification,
    HandleCache,
    UpdateOverlay,
    OfflineIndicator,
    //Authenticator, // Add the Authenticator component
  },

  setup() {

    const store = useStore();
    //const router = useRouter();
    const route = useRoute();

    const hasContentLoaded = ref(false)
    const tokenRefreshInterval = ref(null)
    const isLoading = computed(() => store.state.loading.isLoading)
    const initializationError = ref(null);
    const cacheBuster = ref(null)

    // route that should be exlusivley for mobile only and loaded with the mobile layout
    const isMobileRoute = computed(() => {
      //console.log('Current route name:', route.name); // Debugging line
      return route.name === 'MobileDashboard' || route.name === 'MobileTreasureChest'|| route.name === 'MobileJourneyMap' || route.name === 'MobileAccount'
      || route.name === 'MobileSettings' || route.name === 'MobileNotifications' || route.name === 'MobileChat' // Add other mobile route names if needed
    })

    // pages on the normal layouts but only available on mobile
    const isMobilePage = computed(() => {
      //console.log('Current route name:', route.name); // Debugging line
      return route.name === 'MobileJourneyView' || route.name === 'Logon'// Add other mobile route names if needed
    })

    //const { isMobile } = useDevice();
    const { isMobile, os, isPwaInstalled } = useDevice();

    const isLoggedIn = computed(() => {
      return store.state.auth.loggedIn
    })

    const showMobileNav = ref(false);

    const updateShowMobileNav = () => {
      const mediaQuery = window.matchMedia('(max-width: 535px)');
      //console.log('Media query matches:', mediaQuery.matches);
      showMobileNav.value = mediaQuery.matches;
    };








    const isAuthenticated = computed(() => store.state.auth.loggedIn);
    const bearerToken = computed(() => store.state.auth.bearer);

    const hexToRgb = (hex) => {
      const value = hex.replace('#', '');
      const bigint = parseInt(value, 16);

      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return `${r}, ${g}, ${b}`;
    };

    const tenantcolor = computed(() => {
      const colors = {
        '--primary-color': store.state.tenant.tenantinfo.primarycolor,
        '--primary-color-rgb': hexToRgb(store.state.tenant.tenantinfo.primarycolor),
        '--primary-color-hover': decrease_brightness(
          store.state.tenant.tenantinfo.primarycolor,
          20
        ),
        '--primary-color-disabled': increase_brightness(
          store.state.tenant.tenantinfo.primarycolor,
          30
        ),
        '--secondary-color': store.state.tenant.tenantinfo.secondarycolor,
        '--secondary-color-rgb': hexToRgb(store.state.tenant.tenantinfo.secondarycolor),
        '--secondary-color-hover': decrease_brightness(
          store.state.tenant.tenantinfo.secondarycolor,
          20
        ),
        '--secondary-color-disabled': increase_brightness(
          store.state.tenant.tenantinfo.secondarycolor,
          30
        )
      };

      // Mirror variables on :root so teleported elements (v-dialog, v-menu, etc.) can inherit them
      Object.entries(colors).forEach(([key, value]) => {
        if (value) document.documentElement.style.setProperty(key, value);
      });

      return colors;
    });

    const userJourneys = computed(() => store.getters["journey/getUserJourneys"]);
    const userVerifiedFlag = computed(() => store.getters["auth/getCurrentUserVerifiedFlag"]);
    const popupUserNotifications = computed(() => store.getters["userNotifications/getPopupUserNotifications"]);
    const popupAnnouncementMessageUserNotifications = computed(() => store.getters["userNotifications/getPopupAnnouncementMessageUserNotifications"]);

    const currentUserRoles = ref();

    currentUserRoles.value = store.getters["auth/getCurrentUserRoles"];

    const refreshToken = async () => {
      try {
        //console.log('refreshToken called');
        //console.log('Refreshing token...');
        const token = await getAuthToken();
        //console.log('Token refreshed:', token);
        // You might want to update your store with the new token here
        // await store.dispatch('auth/updateToken', token);
      } catch (error) {

        //console.log('error with the refrshToken getting current checkCurrentAuthentiatedUser', error);
        //console.error('Error refreshing token:', error);
        // Handle token refresh error, possibly redirect to login
        // if (error.name === 'NotAuthorizedException') {
        //   await router.push({ name: 'Logon' });
        // }
      }
    }

    const loggedInUserAPICalls = async () => {
      //console.log('is loggedInuserAPICall also called with directl call to deppling?');
      // await store.dispatch('journey/listUserJourneys')
      store.dispatch('userNotifications/fetchUserNotifications');
      // store.dispatch('chat/fetchRooms');
      // await store.dispatch('userPreferences/fetchUserPreferences')
      // await store.dispatch('internalCurrency/getAmount')
      // await store.dispatch('tenantSpecificAssets/getExpeditionLogs');
      // await store.dispatch('tenantSpecificAssets/getMemoryCards');
      if (userVerifiedFlag.value === 'false') {
        await store.dispatch('users/verifyUserEmail');
      }
    }


    const waitForAuthAndToken = () => {
      return new Promise((resolve) => {
        const unwatch = watch(
          () => ({
            isAuthenticated: isAuthenticated.value,
            token: bearerToken.value,
          }),
          (newVal) => {
            if (newVal.isAuthenticated && newVal.token) {
              unwatch();
              resolve();
            }
          },
          { immediate: true }
        );
      });
    };

    // In the script setup section, add a watch for route changes
    watch(route, async (to, from) => {
      const isComingFromCmv = from.path.includes('/cmv') || from.path.includes('/mapping');
      
      // If we're coming from a CMV route, refresh the token
      if (isComingFromCmv) {
        try {
          console.log('Route changed from CMV, refreshing token');
          await getAuthToken();
        } catch (error) {
          console.error('Error refreshing token after CMV navigation:', error);
        }
      }
    });

    // Refresh token when app returns from background/sleep (mobile browsers throttle setInterval)
    const handleVisibilityChange = async () => {
      if (!document.hidden && store.state.auth.loggedIn) {
        try {
          await getAuthToken();
        } catch (error) {
          // console.error('Token refresh failed on visibility change:', error);
        }
      }
    };

    onMounted(async () => {
      // Register offline/online event listeners
      registerCacheListeners(store);

      // Refresh token when the user returns to the app after sleep/background
      document.addEventListener('visibilitychange', handleVisibilityChange);

      try {
        // Always refresh the token on app mount
        await getAuthToken();
      } catch (error) {
        console.error('Error refreshing token on app mount:', error);
      }

      // Rest of your existing onMounted code
      hasContentLoaded.value = true;

        // Wait until both isAuthenticated and token are available
        await waitForAuthAndToken();
        //console.log('both isAuthenticated and isBearerSet is available.', isBearerSet.value);

        // Now both isAuthenticated and bearerToken are set
        await loggedInUserAPICalls();
      tokenRefreshInterval.value = setInterval(refreshToken, 10 * 60 * 1000);
      //console.log('tokenRefreshInterval', tokenRefreshInterval.value);
      updateShowMobileNav();
      window.addEventListener('resize', updateShowMobileNav);

      // const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // console.log(userTimezone);

    });

    onBeforeUnmount(() => {
      store.commit('file/CLEAR_BLOB_CACHE');

      document.removeEventListener('visibilitychange', handleVisibilityChange);
      
      //unsubscribeAuth();
      // Clean up Hub listener if necessary
       // Clear the interval when the component is destroyed
       if (tokenRefreshInterval.value) {
        clearInterval(tokenRefreshInterval.value);
      }
      //Hub.remove('auth')
      window.removeEventListener('resize', updateShowMobileNav);
    });

    // Watch for changes in authentication and token
    watch(
      () => ({
        isAuthenticated: isAuthenticated.value,
        token: bearerToken.value,
      }),
      async (newVal, oldVal) => {
        if (
          newVal.isAuthenticated &&
          newVal.token &&
          (!oldVal.isAuthenticated || !oldVal.token)
        ) {
          // User has just logged in and token is now available
          //console.log('User has just logged in and token is now available');
          await loggedInUserAPICalls();
        } else if (
          (!newVal.isAuthenticated || !newVal.token) &&
          oldVal.isAuthenticated &&
          oldVal.token
        ) {
          //console.log('User has logged out or token is no longer available');
          // User has logged out or token is no longer available
          // Optionally handle logout logic here
        }
      }
    );

    return {
      hasContentLoaded,
      store,
      isAuthenticated,
      isLoading,
      tenantcolor,
      isMobileRoute,
      isMobilePage,
      isMobile,
      isLoggedIn,
      showMobileNav,
      cacheBuster,
      //isAmplifyConfigured,
      initializationError,
      popupUserNotifications,
      popupAnnouncementMessageUserNotifications,
      // Service worker update prompt (single source of truth)
      updateAvailable,
      applyUpdate
    }
  },

}
</script>

<style lang="scss">
:root {
  color-scheme: light;
}

html, body {
  background-color: #fff;
}

// Bootstrap's reboot (button { border-radius: 0 }) is unlayered, so it beats Vuetify's layered button radius
// (.v-btn defaults, rounded="..." utilities) and every v-btn ends up square. revert-layer gives the radius back to Vuetify
button.v-btn {
  border-radius: revert-layer;
}

// same for Bootstrap's textarea { resize: vertical }: it beats Vuetify's layered resize: none, so no-resize / auto-grow
// v-textareas (Vuetify adds v-textarea--no-resize for both) could still be resized by dragging the corner
.v-textarea--no-resize textarea.v-field__input {
  resize: none;
}

// quiz fields (v-textarea / v-text-field variant="solo-filled" flat class="quiz-field"): light grey field, no outline
.quiz-field .v-field {
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  background-color: #f9f9f9;
}

// solo-filled puts a currentColor overlay over the field (darker at rest, more on hover / focus), the field keeps its own color
.quiz-field .v-field__overlay {
  background-color: transparent;
}

// focus effect, same as the old .effect-7 textareas: 2px tenant color lines grow from the middle of each edge.
// top / bottom lines on the outline element, left / right lines on the field (solo-filled doesn't use these pseudo elements)
.quiz-field .v-field__outline::before,
.quiz-field .v-field__outline::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: 0.4s;
  z-index: 1;
}

.quiz-field .v-field__outline::after {
  top: auto;
  bottom: 0;
}

.quiz-field .v-field::before,
.quiz-field .v-field::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 2px;
  height: 0;
  background-color: var(--primary-color);
  transition: 0.6s;
  z-index: 1;
  pointer-events: none;
}

.quiz-field .v-field::after {
  left: auto;
  right: 0;
}

.quiz-field .v-field--focused .v-field__outline::before,
.quiz-field .v-field--focused .v-field__outline::after {
  left: 0;
  width: 100%;
}

.quiz-field .v-field--focused::before,
.quiz-field .v-field--focused::after {
  top: 0;
  height: 100%;
}

.content {
  display: block;
  .bottombar {
    width: 100%;
    background-color: var(--primary-color) !important;
  }
  .main {
    width: 100%;
  }
  @media only screen and (min-width: 534px) {
    #mobile {
      display: none;
    }
  }
  @media only screen and (max-width: 535px) {
    #mobile {
      display: block;
    }
  }
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  background-color: var(--primary-color-hover) !important;
  color: #fff !important;
  border-color: var(--primary-color-hover) !important;
  box-shadow: none !important;
}

.btn-primary {
  color: #fff !important;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.nav > a {
  float: left;
  position: relative;
  font-size: 0.8rem;
}
/* Style the links inside the navigation bar */
.nav a {
  color: gray;
}

.nav a:hover {
  border-bottom: 3px solid var(--primary-color-hover);
  color: var(--primary-color);
}

.nav a.active {
  border-bottom: 3px solid var(--primary-color);
  color: var(--primary-color);
}

.form-check-input:checked {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}
.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: var(--primary-color-hover) !important;
}

.h4,
h4 {
  font-size: 0.9375rem !important;
}
.small,
small {
  font-size: 0.8125rem !important;
}
.progress-sm {
  height: 0.25rem !important;
}
.avatar-img {
  -o-object-fit: cover;
  object-fit: cover;
  margin: 2px !important;
}

.rounded-circle {
  border-radius: 50% !important;
}
img,
svg {
  vertical-align: middle !important;
}
.btn-white {
  border-color: var(--primary-color) !important;
}
.btn-check:focus + .btn-white,
.btn-white,
.btn-white:focus,
.btn-white:hover {
  color: var(--primary-color) !important;
  background-color: #fff;
  border-color: var(--primary-color) !important;
  box-shadow: none !important;
}
.nav.btn-group .btn-white.active {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: #fff !important;
}
.badge.bg-primary-soft {
  color: white;
  text-decoration: none;
}

.badge {
  vertical-align: bottom;
}
.bg-primary-soft {
  background-color: lightgray;
}
.badge {
  display: inline-block;
  padding: 0.5em 0.5em !important;
  font-size: 76%;
  font-weight: 400;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
}

.invalid-feedback {
  display: block !important;
  width: 100%;
  margin-top: 0;
  font-size: 0.8125rem;
  color: #e63757;
}
.input-group-merge.input-group-reverse {
  display: flex;
  flex-direction: row-reverse;
}
.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group-lg.input-group-merge.input-group-reverse:not(.input-group-rounded)
  > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu) {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.input-group-lg.input-group-merge.input-group-reverse > .form-control {
  padding-right: 1.25rem !important;
  border-radius: 0 0.5rem 0.5rem 0 !important;
}
.input-group-merge.input-group-reverse > .form-control {
  padding-right: 0.75rem;
  padding-left: 0;
  border-radius: 0 0.375rem 0.375rem 0;
  border-right-width: 1px;
  border-left-width: 0;
}
.input-group-lg.input-group-merge.input-group-reverse:not(.input-group-rounded)
  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}
.input-group-lg.input-group-merge.input-group-reverse > .input-group-text {
  border-radius: 0.5rem 0 0 0.5rem !important;
  border-right-width: 0;
}
.input-group-merge > .input-group-text {
  border-left-width: 1;
  border-right-width: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.input-group-lg > .btn,
.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text {
  padding: 0.75rem 1.25rem;
  font-size: 0.9375rem;
  border-radius: 0.5rem;
}
.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #95aac9 !important;
  text-align: center;
  white-space: nowrap;
  background-color: #fff !important;
  border: 1px solid #d2ddec;
  border-radius: 0.375rem;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #12263f;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2ddec;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-orange-button {
    background-color: initial;
    background-image: linear-gradient(-180deg, #FF7E31, #E62C03);
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
    color: #FFFFFF;
    cursor: pointer;
    padding: 0 20px;
    text-align: center;
    border: 0;
    transition: box-shadow .2s;
    font-size: 20px;

    &:hover {
      box-shadow: rgba(253, 76, 0, 0.5) 0 3px 8px;
    }

}

.table-textarea {
  font-size: 14px;
  padding: 12px 20px;
  border-radius: 4px;
  resize: none;
  &:focus{
    outline: none;
  }
}

//table {
//  border-collapse: collapse;
//  display: block;
//  overflow: auto;
//  max-width: 100%;
//  max-height: 50vh;
//  white-space: nowrap;
//  width: fit-content;
//  position: relative;
//  box-shadow: rgba(60, 66, 87, 0.12) 0 7px 14px 0, rgba(0, 0, 0, 0.12) 0 3px 6px 0;
//}
//
//table thead {
//  position: sticky;
//  top: 0;
//}
//table thead th{
//  background-color: #f1f6fc;
//}
//
//table tr:last-child td {
//  border-bottom: none;
//}
//
//table tr td {
//  border-right: none;
//  background-color: white;
//  color: black
//}
//
//table tr th {
//  //background-color: white;
//  color: black
//}
//
//table tr th i {
//  cursor: pointer;
//}
//
//table tr td:first-child, table tr th:first-child {
//  border-left: none;
//}
//
//table, table td, table th {
//  border-collapse: collapse;
//  font-size: 14px;
//  text-align: center;
//}
//table td.company {
//  font-weight: 600;
//}
//table tr {
//  border: 1px solid #ebebeb;
//}
//
//table tr td, table tr th {
//  padding: 10px;
//  h2 {
//    font-weight: 600;
//    font-size: 16px !important;
//  }
//}
//
//table td.action {
//  position: unset;
//  display: flex;
//}
//
//table td.action img {
//  width: 35px;
//  cursor: pointer;
//  margin: auto;
//}

input, select {
  &:focus {
    outline: none;
  }

}

.disabled {
  pointer-events: none;
  opacity: 0.3;
  cursor: not-allowed;
  background-image: unset;
  background-color: #9e9191;
}

.side-by-side {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.icon {
  cursor: pointer;
}
div.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom_modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 13;

  &__content {
    background-color: rgba(232, 231, 231);
    width: 590px;
    max-height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    z-index: 14;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    border: 1px solid black;
    font-size: 18px;
    text-align: center;
    overflow: auto;

    h3 {
      font-weight: bold;
      text-transform: uppercase;
    }

    .buttons-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
    }

  }

  .backdrop {
    background-color: rgb(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

}

.editorx_body {
  min-height: 200px;
  border: 2px solid #c8c8c8c8;
  box-sizing: border-box;
  background-color: white;

  .cdx-block {
    &.embed-tool {
      padding-right: 100px;
      cursor: text;
    }

    //&.image-tool {
    //  .image-tool__image {
    //    img.image-tool__image-picture {
          //width: 100%;
    //    }
    //  }
    //}
  }

  //.ce-block {
  //  img {
  //    width: 100%;
   // }
 // }
}

.editorjs-video-tool {
  &__dropzone {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    background: #fafafa;

    &--active {
      border-color: var(--primary-color);
      background: #f0f7ff;
    }

    &--uploading {
      pointer-events: none;
      background: #f5f5f5;
      border-color: #ddd;
      cursor: default;
    }
  }

  &__uploading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    margin-top: 0.5rem;
  }

  &__uploading-text {
    font-size: 0.9rem;
    color: #555;
  }

  &__spinner {
    width: 28px;
    height: 28px;
    border: 3px solid #e0e0e0;
    border-top-color: var(--primary-color);
    border-radius: 50%;
    animation: editorjs-video-tool-spin 0.8s linear infinite;
  }

  @keyframes editorjs-video-tool-spin {
    to {
      transform: rotate(360deg);
    }
  }

  &__hint {
    font-size: 0.85rem;
    color: #888;
  }

  &__progress {
    margin-top: 1rem;
    height: 8px;
    background: #e0e0e0;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }

  &__progress-bar {
    height: 100%;
    width: 0;
    background: var(--primary-color);
    transition: width 0.2s ease;
  }

  &__progress-text {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.85rem;
  }

  &__preview {
    padding: 1rem;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: flex-start;
  }

  &__badge {
    display: inline-block;
    padding: 0.2rem 0.6rem;
    background: var(--primary-color);
    color: #fff;
    border-radius: 4px;
    font-size: 0.75rem;
    margin-bottom: 0.5rem;
  }

  &__replace {
    margin-top: 0.75rem;
    padding: 0.4rem 0.8rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
  }

  &__actions {
    margin-top: 0.75rem;
    text-align: center;
  }

  &__choose-existing {
    padding: 0.4rem 0.8rem;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    background: #fff;
    color: var(--primary-color);
    cursor: pointer;
    font-size: 0.9rem;
  }

  &__preview-thumb {
    width: 120px;
    height: 68px;
    max-width: 120px;
    object-fit: cover;
    border-radius: 6px;
    background: #ddd;
    flex-shrink: 0;

    &--placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      font-size: 0.85rem;
    }
  }

  &__preview-info {
    flex: 1;
    min-width: 140px;
  }

  &__filename {
    font-weight: 600;
    margin: 0.25rem 0;
    word-break: break-word;
  }

  &__duration {
    font-size: 0.85rem;
    color: #666;
    margin: 0;
  }

  &__library {
    padding: 0.5rem 0;
  }

  &__library-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }

  &__library-back {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
  }

  &__library-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
  }

  &__library-loading,
  &__library-empty {
    color: #666;
    font-size: 0.9rem;
    padding: 1rem 0;
  }

  &__library-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 110px));
    gap: 0.5rem;
    max-height: 280px;
    overflow-y: auto;
  }

  &__library-item {
    position: relative;
    border: 1px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: var(--primary-color);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
  }

  &__library-thumb {
    width: 100%;
    height: 62px;
    max-height: 62px;
    object-fit: cover;
    display: block;
    background: #eee;

    &--placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #888;
      font-size: 0.75rem;
    }
  }

  &__library-meta {
    padding: 0.35rem 0.4rem;
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
  }

  &__library-filename {
    font-size: 0.7rem;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__library-duration,
  &__library-date {
    font-size: 0.65rem;
    color: #888;
  }

  &__library-delete {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 0.9rem;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    &:hover {
      background: #c62828;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &__library-item--confirming {
    .editorjs-video-tool__library-thumb {
      opacity: 0.35;
    }
  }

  &__library-confirm {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: rgba(255, 255, 255, 0.92);
    padding: 0.4rem;
  }

  &__library-confirm-text {
    margin: 0 0 0.4rem;
    font-size: 0.65rem;
    line-height: 1.3;
    color: #333;
  }

  &__library-confirm-actions {
    display: flex;
    gap: 0.35rem;
  }

  &__library-confirm-cancel,
  &__library-confirm-delete {
    flex: 1;
    padding: 0.25rem 0.35rem;
    border-radius: 4px;
    font-size: 0.65rem;
    cursor: pointer;
    border: 1px solid #ccc;
    background: #fff;
  }

  &__library-confirm-delete {
    background: #c62828;
    border-color: #c62828;
    color: #fff;

    &:hover:not(:disabled) {
      background: #b71c1c;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  &__library-error {
    margin: 0 0 0.35rem;
    font-size: 0.6rem;
    color: #c62828;
    line-height: 1.2;
  }

  &__error {
    color: #c62828;
    padding: 1rem;
  }
}

.ce-block--focused {
  //background: linear-gradient(
  //        90deg,
  //        rgba(2, 0, 36, 1) 0%,
  //        rgba(9, 9, 121, 0.5438550420168067) 35%,
  //        rgba(0, 212, 255, 1) 100%
  //);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.separator {
  width: 100%;
  height: 1px;
  background-color: black;
}

.custom-input-wrapper {
  position: relative;
  width: 100%;
  border: 1px solid transparent;
  background-color: #f9f9f9;

  input[type="text"], input[type="email"], textarea {
    color: #333;
    width: 100%;
    box-sizing: border-box;
    letter-spacing: 1px;
    border: none;
    min-height: 40px;
    overflow: hidden;
    background-color: transparent;

    &.effect-7 {
      padding: 7px 14px 9px;
      transition: 0.4s;

      & ~ .focus-border:before,
      & ~ .focus-border:after {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background-color: var(--primary-color) !important;;
        transition: 0.4s;
      }

      & ~ .focus-border:after {
        top: auto;
        bottom: 0;
      }

      & ~ .focus-border i:before,
      & ~ .focus-border i:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 2px;
        height: 0;
        background-color: var(--primary-color) !important;
        transition: 0.6s;
      }

      & ~ .focus-border i:after {
        left: auto;
        right: 0;
      }

      &:focus ~ .focus-border:before,
      &:focus ~ .focus-border:after {
        left: 0;
        width: 100%;
        transition: 0.4s;
      }

      &:focus ~ .focus-border i:before,
      &:focus ~ .focus-border i:after {
        top: 0;
        height: 100%;
        transition: 0.6s;
      }

    }

  }

  textarea {
    border: none;
    overflow: auto;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;

    resize: none; /*remove the resize handle on the bottom right*/
  }

}

.checkbox-wrapper {
  label {
    cursor: pointer;
  }
  input[type="checkbox"] {
    cursor: pointer;
    accent-color: var(--primary-color);
  }
}

.custom-input-1 {
  position: relative;
  margin: 20px 0;
  cursor: pointer;

  label {
    position: absolute;
    top: -12px; /* Keep the label always at the top */
    left: 10px;
    font-size: 15px;
    color: var(--primary-color); /* Use a primary color for visibility */
    background-color: white; /* Add background for contrast */
    padding: 0 5px;
  }

  input {
    font-size: 16px;
    padding: 14px 10px 10px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    width: 100%;
    transition: border-color 0.3s ease;

    &:focus {
      border-color: var(--primary-color);
      box-shadow: 0 0 5px var(--primary-color);
    }
  }
}

.custom-table-wrapper {

  .card {
    background: #f7f8fa; // lightgray;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    //background-color: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    width: 100%;
    margin: 0 auto 1rem auto;

    //@media (min-width: 768px) {
    //  width: 80%;
    //}
    //
    //@media (min-width: 1024px) {
    //  width: 50%;
    //}

    .card-header {
      padding: 1rem;
      border-bottom: 1px solid #e5e7eb;

      .text-2xl {
        font-size: 1.5rem;
        margin-bottom: 0;
      }

      .font-light {
        font-weight: 300;
      }

    }

    .card-content {
      padding: 1rem;

      .custom-table {
        max-width: 100%;
        overflow: auto;

        .table-header,
        .table-row {
          display: flex;
          justify-content: flex-start;
          width: 100%;
        }

        .table-header {
          font-weight: bold;
          margin: 10px 0;

          &.header-sticky {
            position: sticky;
            top: -1px;
            z-index: 3;
          }

          .table-column {
            border-bottom: 1px solid #e9e4e4;
          }
        }

        .table-row {
          font-weight: 300; /* Light font for text */
          .pre-table-column {
            display: flex;
            width: 100%;
            margin: 10px 0;
          }
        }

        .table-column {
          flex: 1;
          text-align: left;
          min-width: 20%;
          //border-bottom: 1px solid #e5e7eb; /* Light horizontal line below header */
          padding: 0.75rem 1rem;
          background-color: white;

          &:first-child {
            //padding-left: 0;
          }
        }
      }
    }

    .pagination {
      padding: 1rem;

      .per-page, .right {
        background: white;
        padding: 5px 0.75rem;
        align-items: center;
      }

      .per-page {
        width: 50%;
        text-align: left;

        select {
          width: fit-content !important;
          min-width: 10px !important;
          cursor: pointer;
        }
      }
      .right {
        width: 50%;
        justify-content: right;
        display: flex;

        .min-max-entries {
          width: fit-content !important;
          padding-right: 1rem;

          .bold {
            font-weight: 500;
          }

          .grey {
            color: grey
          }
        }

        .next-previous-page {
          font-weight: 500;
          width: fit-content !important;
          cursor: pointer;

          span {
            &.prev, &.next {
              padding: 0 10px;
            }

            &.grey {
              color: grey;
              cursor: default;
            }
          }
        }
      }
    }

    .card-footer {
      padding: 1rem;
      border-top: 1px solid #e5e7eb;
    }

  }

}

.container_wrapper {
  max-width: 95% !important;
}

.page_wrapper {
  padding: 20px 20px 70px 20px;
  min-height: 100vh;
}

.converted-html-element.element {
  margin: 20px 0;
  transition: all 0.2s ease;

 // img {
 //   width: 75%;
 // }

  ol.list {
    list-style: none;
    counter-reset: item;
    padding-left: 20px;
  }

  ol.list > li {
    counter-increment: item;
    position: relative;
  }

  ol.list > li::before {
    content: counters(item, ".") ". ";
    font-weight: 500;
    margin-right: 6px;
  }

  ol.numeric { counter-reset: item; }
  ol.lower-roman { counter-reset: item; }

  ul.list {
    list-style: disc;
    padding-left: 20px;
  }

  ul.list li::before {
    content: none;
  }

  li {
    text-align: left;
    margin-bottom: 6px;
  }

  .list-content {
    display: inline;
  }

  //ol {
  //  padding-left: 20px;
  //  margin: 0;
  //}
  //
  //li {
  //  text-align: left;
  //  margin: 0 0 8px 0;
  //  position: relative;
  //}
  //
  ///* CONTENT */
  //.list-content {
  //  display: inline-block;
  //}
  //
  ///* -------------------------
  //   ORDERED LIST BASE
  //--------------------------*/
  //ol.list {
  //  --counter-style: decimal;
  //}
  //
  //ol.list.lower-roman {
  //  --counter-style: lower-roman;
  //}
  //
  //ol.list > li::before {
  //  content: counter(item, var(--counter-style)) ".";
  //}
  //
  //ol.list {
  //  list-style: none;
  //  counter-reset: item;
  //}
  //
  //ol.list > li {
  //  counter-increment: item;
  //}
  //
  //ol.list > li::before {
  //  margin-right: 8px;
  //  font-weight: 500;
  //  display: inline-block;
  //}
  //
  ///* -------------------------
  //   COUNTER TYPES
  //--------------------------*/
  //
  ///* numeric (default) */
  //ol.list.numeric > li::before {
  //  content: counter(item) ".";
  //}
  //
  ///* lower roman */
  //ol.list.lower-roman > li::before {
  //  content: counter(item, lower-roman) ".";
  //}
  //
  ///* upper roman */
  //ol.list.upper-roman > li::before {
  //  content: counter(item, upper-roman) ".";
  //}
  //
  ///* lower alpha */
  //ol.list.lower-alpha > li::before {
  //  content: counter(item, lower-alpha) ".";
  //}
  //
  ///* upper alpha */
  //ol.list.upper-alpha > li::before {
  //  content: counter(item, upper-alpha) ".";
  //}
  //
  ///* -------------------------
  //   UNORDERED LIST
  //--------------------------*/
  //
  //ul.list {
  //  list-style: disc;
  //}
  //
  ///* -------------------------
  //   NESTED INDENTATION
  //--------------------------*/
  //
  //.level-1 {
  //  margin-left: 20px;
  //}
  //
  //.level-2 {
  //  margin-left: 40px;
  //}
  //
  //.level-3 {
  //  margin-left: 60px;
  //}

  .converted-image-wrapper {
    margin: 1rem 0;

    &.stretched {
      img {
        width: 100%;
      }
    }

    &.withBorder {
      img {
        border: 1px solid #e8e8eb;
      }
    }

    &.withBackground {
      background: #eff2f5;
      padding: 10px;

      img {
        display: block;
        max-width: 60%;
        margin: 0 auto 15px;
      }
    }
  }

  .journey-video-wrapper {
    margin: 1.5rem 0;
    max-width: 100%;

    .plyr {
      --plyr-color-main: var(--primary-color);
      border-radius: 8px;
      overflow: hidden;
    }

    .journey-video-notice {
      margin-top: 0.75rem;
      padding: 0.65rem 0.85rem;
      border-radius: 6px;
      font-size: 0.85rem;
      line-height: 1.4;
      text-align: center;
    }

    .journey-video-notice--info {
      background: #eef4ff;
      color: #1e3a8a;
    }

    .journey-video-notice--error {
      background: #fef2f2;
      color: #991b1b;
    }

    .journey-video-caption {
      margin-top: 0.5rem;
      font-size: 0.9rem;
      color: #666;
      text-align: center;
    }
  }

  .checklist-old {

    .checkbox-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 10px;

      input[type="checkbox"] {
        margin-top: 5px;
        scale: 1.2;
        border-radius: 4px;
        transition: all 0.2s ease;

        //&:checked + .element-wrapper {
        //  background-color: unset;
        //
        //  .element {
        //    opacity: 0.7;
        //    text-decoration: line-through;
        //    color: #6c757d;
        //    font-weight: 500;
        //
        //    img {
        //      opacity: 0.7;
        //    }
        //  }
        //}
      }

      label {
        cursor: default;
      }

    }
  }

  .checklist {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .checkbox-wrapper {
      display: flex;
      flex-direction: column;
    }

    .checkbox-item {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;

      input[type='checkbox'] {
        margin-top: 3px;
        flex-shrink: 0;
      }
    }

    .checklist-content {
      line-height: 1.5;
    }

    /* nested indentation */
    &.level-1 {
      margin-left: 24px;
    }

    &.level-2 {
      margin-left: 48px;
    }

    &.level-3 {
      margin-left: 72px;
    }
  }

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    margin: 20px 0;

    &.stretched {
      .converted-table {
        width: 100%;
      }
    }
  }

  .converted-table {
    border-collapse: collapse;
    margin: 0 auto;
    max-width: 100%;
    white-space: break-spaces;
    
    thead {
      background: var(--primary-color);
      color: #fff;
    }

    th,
    td {
      border: 1px solid #dcdcdc;
      padding: 10px 14px;
      text-align: left;
      vertical-align: top;
    }

    th {
      font-weight: 600;
    }

    tbody tr:nth-child(even) {
      background: rgba(0, 0, 0, 0.03);
    }

    /* textVariant examples */
    &.call-out {
      font-size: 1.05rem;
    }

    &.small {
      font-size: 0.9rem;
    }
  }

  .call-out {
    border: 1px solid rgb(255, 135, 135);
    padding: 8px 16px;
    border-radius: 6px;
    box-shadow: 0 0 0 5px rgba(255, 120, 84, 0.16);
  }

  .citation {
    font-style: italic;
  }

  .details {
    font-size: 0.84em;
  }

  .quote {
    position: relative;
    width: 100%;
    margin: auto;
    padding: 1rem;
    background-color: transparent;
    background-position: top left, 0.2em 0.2em;
    background-repeat: no-repeat;
    filter: drop-shadow(0 0 15px #0005);

    &::before,
    &::after {
      position: absolute;
      z-index: -1;
      display: block;
      width: 3rem;
      height: 4rem;
      content: "";
      font-size: 90px;
      font-family: Georgia, Times, Garamond, serif;
    }

    &::before {
      top: -2.5rem;
      left: 0.5rem;
      content: open-quote;
    }

    &::after {
      bottom: -1rem;
      right: 0;
      content: close-quote;
    }

    &::before,
    &::after,
    & blockquote {
      text-shadow: -2px 2px #fff, -1.5px 1.5px #fff, -1px 1px #fff, -0.5px 0.5px #fff;
    }

    & figcaption,
    & blockquote {
      margin: 20px;
    }

    & figcaption {
      text-align: right;
    }
  }

  .delimiter {
    text-align: center;

    &:before {
      display: inline-block;
      content: "***";
      font-size: 30px;
      line-height: 65px;
      height: 30px;
      letter-spacing: 0.2em;
    }
  }

  .columns-wrapper {
    display: flex;
    gap: 10px;
    padding: 10px 0;
  }

}

button.text-primary {
  background: var(--primary-color) !important;
  color: white !important;
}

.v-dialog {
  .v-card {
    .v-divider {
      margin: 10px 0;
    }
  }
  .v-card-title {
    padding-top: 15px;
    padding-bottom: 0;
  }

}

// shared v-card wrapper around the app's tables: v-card + __header (v-card-title) / __title / __content (v-card-text);
// per-page layout tweaks (header alignment, gaps, colors) stay in each component
.app-table-card {
  background: #f7f8fa;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  margin: 0 auto 1rem auto;

  &__header {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 1rem;
    //border-bottom: 1px solid #e5e7eb;
    // undo v-card-title's single-line text styles so header controls (search, dropdowns) aren't clipped
    overflow: visible;
    white-space: normal;
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 300;
    margin-bottom: 0;
  }

  &__content {
    padding: 1rem;
  }
}

// the "per page" dropdown menu is teleported out of the table, so it gets its own class (set in src/vuetify/index.js defaults)
.app-data-table-per-page-menu {
  .v-list {
    padding: 4px 0;
  }

  .v-list-item {
    min-height: 28px;
    padding: 0 12px;
  }

  .v-list-item-title {
    font-size: 13px;
  }
}

// shared look for every v-data-table in the app (header + footer/pagination);
// table-specific rules (cell padding, cell content, scroll height) stay in each component
.app-data-table {

  thead th {
    font-weight: bold;
    white-space: nowrap;
  }

  .v-divider {
    display: none;
  }

  .v-data-table-footer {
    padding: 6px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 13px;
    color: #515151;
    border-top: 1px solid #e5e7eb;
  }

  .v-data-table-footer__items-per-page {
    display: flex;
    align-items: center;
    font-size: 13px;

    // shrink Vuetify's 40px compact select to the 28px height of the pagination buttons
    .v-select {
      width: fit-content;
      font-size: 13px;

      .v-field {
        padding: 0;
      }

      .v-field__field {
        align-items: center;
      }

      .v-field__input {
        min-height: 28px;
        padding: 0 0 0 8px;
        align-items: center;
      }

      .v-select__selection-text {
        font-size: 14px;
      }

      .v-field__append-inner {
        padding-inline-start: 0;
        padding-inline-end: 4px;
        padding-top: 0;
        align-items: center;

        .v-icon {
          font-size: 18px;
        }
      }
    }
  }

  .v-data-table-footer__info {
    font-size: 13px;
    color: #6b7280;
  }

  .v-pagination__list {
    margin-bottom: 0;
  }

  .v-pagination__item {
    min-width: 28px;
    height: 28px;
    font-size: 13px;
  }

  .v-pagination__prev,
  .v-pagination__next {
    min-width: 28px;
    height: 28px;
  }

  @media (max-width: 599px) {
    .v-data-table-footer {
      padding: 8px 10px;
      gap: 6px;
    }

    .v-data-table-footer__pagination {
      order: 1;
      width: 100%;
      justify-content: center;
      margin-inline-start: 0;
    }

    .v-pagination__list {
      justify-content: center;
    }

    .v-data-table-footer__items-per-page {
      order: 2;
      flex: 0 0 auto;

      > span {
        display: none;
      }
    }

    .v-data-table-footer__info {
      order: 3;
      flex: 1;
      justify-content: flex-end;
      min-width: unset;
      padding: 0 4px;
    }
  }
}

.v-selection-control {
  .v-label {
    height: fit-content;
  }
}

</style>
